import { parseData, post } from './common';
import { responseHandler } from '../api/api';
const getEmailAddresses = (payload) => {
    return post('/InternalAPI/EmailAPI.asmx/GetEmailAddresses', payload)
        .then(parseData)
        .then(responseHandler);
};
const sendEmail = (payload) => {
    return post('/InternalAPI/EmailAPI.asmx/SendEmail', payload)
        .then(parseData)
        .then(responseHandler);
};
export { getEmailAddresses, sendEmail };
